// store/usePetsittingMode.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { Constants } from '@/assets'

type PetsittingModeState = {
  isPetsittingMode: boolean
  setPetsittingMode: (value: boolean) => void
  togglePetsittingMode: () => void
}

const initialPetsittingMode = Constants?.petsitting === 'true' || Constants?.petsitting === true

export const usePetsittingMode = create<PetsittingModeState>()(
  persist(
    (set) => ({
      isPetsittingMode: initialPetsittingMode,

      setPetsittingMode: (value) => set({ isPetsittingMode: value }),

      togglePetsittingMode: () =>
        set((state) => ({
          isPetsittingMode: !state.isPetsittingMode,
        })),
    }),
    {
      name: 'petsitting-mode-storage',
    },
  ),
)
